import featureVotesRepository, {
  CreateFeatureVotePayload,
  FeatureVoteResponse,
  FeatureName,
  VoteType,
} from "../repositories/feature-votes.repository";

interface VoteFeatureRequest {
  featureName: FeatureName;
  voteType: VoteType;
  description: string;
}

class FeatureVotesService {
  async createFeatureVote(
    payload: VoteFeatureRequest
  ): Promise<FeatureVoteResponse> {
    if (!payload.featureName) {
      throw new Error("Feature name is required");
    }

    if (!payload.voteType) {
      throw new Error("Vote type is required");
    }

    const request: CreateFeatureVotePayload = {
      featureName: payload.featureName,
      voteType: payload.voteType,
      description: payload.description || "",
    };

    return await featureVotesRepository.createFeatureVote(request);
  }

  async getFeatureVoteByUserAndFeature(
    userId: number,
    featureName: FeatureName,
  ): Promise<FeatureVoteResponse | null> {
    if (!userId) {
      throw new Error("User ID is required");
    }

    if (!featureName) {
      throw new Error("Feature name is required");
    }

    const votes = await featureVotesRepository.getFeatureVoteByUserAndFeature(userId, featureName);
    return votes.length > 0 ? votes[0] : null;
  }
}

export default new FeatureVotesService();